module.exports = __webpack_public_path__ + "static/img/support_7.95ae6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_7.png
// module id = Wtwo
// module chunks = 0